/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing loaders, spinners, or progress related components.
 * @module LoaderModule
 * @preferred
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClrProgressBarModule } from '@clr/angular';

import {
    AviProgressBarComponent,
} from './components';

const loaderComponents = [
    AviProgressBarComponent,
];

@NgModule({
    declarations: [
        ...loaderComponents,
    ],
    imports: [
        CommonModule,
        ClrProgressBarModule,
    ],
    exports: [
        AviProgressBarComponent,
    ],
})
export class LoaderModule {}
